<template>
  <div>
    <h3>
      <span>{{ $t('message.script_config_email') | title }}</span>
      <span class="wiki-link">
        <a :href="$t('message.script_config_email_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <div v-if="description">{{description}}</div>

    <b-form>
      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_server')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="text" v-model="emailConfig.MAIL_SERVER"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_server_port')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="number" v-model="emailConfig.MAIL_PORT"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_username')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="text" v-model="emailConfig.MAIL_USERNAME" autocomplete="new-username"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_password')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="password" v-model="emailConfig.MAIL_PASSWORD"
            :placeholder="$t('message.no_change')" autocomplete="new-password"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_default_sender')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="email" v-model="emailConfig.MAIL_DEFAULT_SENDER"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_passman_link_url')}}
          </label>
        </div>
        <div class="col-8">
          <b-form-input type="url" v-model="emailConfig.PASSMAN_LINK_URL"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.email_use_tls')}}
          </label>
        </div>
        <span class="col">
          <div class="col-4 form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="emailConfig.MAIL_USE_TLS"/>
          </div>
        </span>
      </b-form-row>

      <div>
        <b-button class="padmin-button submit-button" @click="save"
          :disabled="runInProgress" variant="primary">
          <b-spinner v-if="runInProgress" small type="grow"/>
          {{$t('message.button_save') | title}}
        </b-button>

        <b-button class="padmin-button" v-b-modal.send-test-mail-modal>
          {{$t('message.email_send_test')}}
        </b-button>
      </div>

    </b-form>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

    <b-modal id="send-test-mail-modal" hide-footer @show='onTestEmailModalShow'
      :title="$t('message.send_test_mail_title') | title">
      <b-form>
        <b-form-row>
          <div class="col-4">
            <label class="label label-default">
              {{$t('message.email_recipient')}}
            </label>
          </div>
          <div class="col-8">
            <b-form-input type="email" v-model="testEmail.recipient"/>
          </div>
        </b-form-row>

        <b-form-row>
          <div class="col-4">
            <label class="label label-default">
              {{$t('message.email_subject')}}
            </label>
          </div>
          <div class="col-8">
            <b-form-input type="text" v-model="testEmail.subject"/>
          </div>
        </b-form-row>

        <b-form-row>
          <div class="col-4">
            <label class="label label-default">
              {{$t('message.email_body')}}
            </label>
          </div>
          <div class="col-8">
            <b-form-textarea v-model="testEmail.body" :rows="5" :required="true" class="col"/>
          </div>
        </b-form-row>

        <b-button class="padmin-button submit-button" @click="sendTestEmail" variant="primary">
          {{$t('message.button_send') | title}}
        </b-button>
      </b-form>

      <b-alert variant="success" :show="testEmailResult.success == true">
        {{$t('message.email_sent_success')}}
      </b-alert>
      <b-alert variant="danger" :show="testEmailResult.success == false">
        {{$t('message.email_sent_failure')}}: {{testEmailResult.errorMessage}}
      </b-alert>

    </b-modal>

  </div>
</template>

<script>
import { get, post } from "../http"
import ConsoleOutput from "./ConsoleOutput"

export default {
  name: "EmailConfig",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      emailConfig: {},
      result: null,
      output: "",
      runInProgress: false,
      testEmail: {recipient: '', subject: '', body: ''},
      testEmailResult: {success: undefined, errorMessage: ''}
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    description() {
      let messageLookup = "message.script_" + this.$route.params.menu + "_" + this.$route.params.script_name + "_description"
      let description = this.$t(messageLookup)
      if (description === messageLookup) {
        return ""
      }
      return description
    }
  },

  methods: {
    getUrl() {
      return ('/scripts/config/email')
    },

    save() {
      this.result = null
      this.output = ''
      this.runInProgress = true

      let data = {email_config: this.emailConfig}

      post(this.getUrl(), data, { "Content-Type": "application/json" }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.runInProgress = false
          if (resp.data.agung_restart_required) {
            this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
          }
        },
        err => {
          this.runInProgress = false
          console.log("err", err)
        }
      )
    },

    load() {
      get(this.getUrl()).then(
        resp => {
          this.emailConfig = resp.data["params"]["email_config"]["value"]
          this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
          this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
        },
        err => {
          console.log("err", err)
        }
      )
    },

    onTestEmailModalShow() {
      this.testEmailResult.success = undefined
    },

    sendTestEmail() {
      this.testEmailResult.success = undefined
      let data = {...this.testEmail, ...this.emailConfig}
      post('/send_mail', data, { "Content-Type": "application/json" }).then(
        resp => {
          this.testEmailResult.success = resp.data.success
          this.testEmailResult.errorMessage = resp.data.error_message
        },
        err => {
          console.log('err', err)
          this.testEmailResult.success = false
          this.testEmailResult.errorMessage = err.statusText
        }
      )
    }
  }
};
</script>
<style>
@import "./../styles/emailConfigComponent.css"
</style>
